var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManualManagement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#C9C9C9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-feather align-middle me-2"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 8,
  x2: 2,
  y2: 22
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 17.5,
  y1: 15,
  x2: 9,
  y2: 15
})));
export default SvgManualManagement;